
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/kakao-talk",
      function () {
        return require("private-next-pages/android/local/kakao-talk/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/kakao-talk"])
      });
    }
  